import { render, staticRenderFns } from "./OpcoesFiscaisGoverno.vue?vue&type=template&id=124a5664&scoped=true&"
import script from "./OpcoesFiscaisGoverno.vue?vue&type=script&lang=js&"
export * from "./OpcoesFiscaisGoverno.vue?vue&type=script&lang=js&"
import style0 from "./OpcoesFiscaisGoverno.vue?vue&type=style&index=0&id=124a5664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a5664",
  null
  
)

export default component.exports